module.exports = __webpack_public_path__ + "static/media/weddingparty81.a042e227.png";